import { SegmentProps } from './props';
import { Segment } from './Segment';

const PlainSegment = (props: SegmentProps) => <Segment {...props} />;

export { PlainSegment };
